import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import dayjs from 'dayjs';

@Component({
  selector: 'timeago-utc',
  template: '<time [attr.datetime]="timestamp">{{ timeago }}</time>',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimeagoUtcComponent {
  @Input('timestamp')
  set _timestamp(timestamp: string) {
    this.timestamp = timestamp;
    this.timeago = dayjs.utc(timestamp).fromNow();
  }

  public timestamp!: string;
  public timeago!: string;
}